export const GET_USER_DETAILS = 'GET_USER_DETAILS'
export const GET_USER_NOTIFICATIONS = 'GET_USER_NOTIFICATIONS'